import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  userInfo: {}, // 유저 정보
  menuInfo: [], // 메뉴 정보
  lanInfo: [], // 언어팩 정보,
  custInfo: [], // 사업장 정보
  companyInfo: {}, // 회사 정보
  fcmReceptionPayload: {}, // FCM 수신 페이로드
};

const BaseInfoSlice = createSlice({
  name: 'BaseInfo',
  initialState,
  reducers: {
    setUserInfo(state, action) {
      state.userInfo = action.payload;
    },
    setMenuInfo(state, action) {
      state.menuInfo = action.payload;
    },
    setLanInfo(state, action) {
      state.lanInfo = action.payload;
    },
    setCustInfo(state, action) {
      state.custInfo = action.payload;
    },
    setCompanyInfo(state, action) {
      state.companyInfo = action.payload;
    },

    setFcmReceptionPayload(state, action) {
      state.fcmReceptionPayload = action.payload;
    },
  },
});

export const BaseInfoActions = BaseInfoSlice.actions;
export default BaseInfoSlice.reducer;
